import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/events/EventCalendarReport.jsx
// — ported as-is (generic module).
const COLUMNS: ReportColumn[] = [
  { key: 'title', label: 'Title' },
  { key: 'start_at', label: 'Starts' },
  { key: 'end_at', label: 'Ends' },
  { key: 'is_public_holiday', label: 'Public Holiday' },
];

export function EventCalendarReport() {
  return (
    <ReportView
      title="Event Calendar"
      description="Full event schedule."
      endpoint="/reports/events/calendar"
      columns={COLUMNS}
      filters={['dateRange']}
    />
  );
}
